// src/pages/RecommendationProjectPage/TechnicalTab/TechnicalTab.tsx

import React from "react";
import CarbonSequestrationChart from "./carbonsequestrationchart";
import { recommendationData } from "../../ProjectPage/components/ProjectInformation";

interface TechnicalTabProps {
  recommendationProjectData: recommendationData;
}

const TechnicalTab: React.FC<TechnicalTabProps> = ({ recommendationProjectData }) => {
  return (
    <section className="grid grid-cols-1 gap-6">
      <CarbonSequestrationChart recommendationProjectData={recommendationProjectData} />
    </section>
  );
};

export default TechnicalTab;
